import { FC } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Flex } from "@chakra-ui/react";
import { routes } from "~/constants";
import { DiagnosticsHeader } from "./DiagnosticsHeader";
import { DiagnosticsNav } from "./DiagnosticsNav";
import { SimpleFooter } from "./SimpleFooter";

export const DiagnosticsLayout: FC = () => {
  const location = useLocation();

  // Determine which pages should have header/footer
  const hasStandardLayout =
    location.pathname === routes.diagnosticsSignIn ||
    location.pathname === routes.diagnosticsDashboard;

  const isPatientForm = location.pathname.startsWith(
    routes.diagnosticsPatientForm,
  );
  const isConfirmation = location.pathname === routes.diagnosticsConfirmation;
  const isIntakePage = location.pathname === routes.diagnosticsIntake;

  if (isPatientForm) {
    // PatientForm has nav with back arrow
    return (
      <Flex direction="column" minH="100vh">
        <DiagnosticsNav />
        <Flex flexGrow={1} w="100%">
          <Outlet />
        </Flex>
      </Flex>
    );
  }

  if (isConfirmation || isIntakePage) {
    // Confirmation and Intake pages have nav with X close button
    return (
      <Flex direction="column" minH="100vh">
        <DiagnosticsNav variant="close" />
        <Flex flexGrow={1} w="100%">
          <Outlet />
        </Flex>
      </Flex>
    );
  }

  if (hasStandardLayout) {
    // SignIn and Dashboard pages have header and footer
    return (
      <Flex direction="column" minH="100vh">
        <DiagnosticsHeader />
        <Flex flexGrow={1} w="100%">
          <Outlet />
        </Flex>
        <SimpleFooter />
      </Flex>
    );
  }

  // Default: just render the outlet
  return <Outlet />;
};
